import { createAffiliateUri, getPotentialGAMClickTracker, parseMarkup } from '../../../utils/index.js';
import { getAuthTgt } from '../../../data-products/index.js';
import { targetConfig as config } from '../data/index.js';
/**
 * `targetCheckout` is the {@link ICheckoutService} for
 * the Target retailer integration
 */
const targetCheckout = {
    config,
    /**
     * `checkout` executes the target-specific functionality to purchase products
     * @param {IRetailerCartItem[]} items - the {@link IRetailerCartItem} array of products to be purchased
     * @param {IRetailerLocation} location - the currently selected {@link IRetailerLocation}
     * @param {IImpactRadius} impactRadiusTracking - object of Impact Radius affiliate tracking values to be appended to the checkout URL
     * @returns {Promise<string>} A Promise resolving to the checkout URL
     */
    checkout: async (targetCheckoutServiceConfig) => {
        // Cobble together the checkout URL
        const processedUrl = targetCheckoutServiceConfig.impactRadius ?
            createAffiliateUri(config.baseURI, targetCheckoutServiceConfig.impactRadius?.subId1, targetCheckoutServiceConfig.impactRadius?.subId2, targetCheckoutServiceConfig.impactRadius?.subId3, targetCheckoutServiceConfig.impactRadius?.sharedId) : config.baseURI;
        const checkoutUrl = new URL(processedUrl);
        const targetCartItems = targetCheckoutServiceConfig.selectedItems.map((item) => {
            return {
                quantity: 1,
                id: item.id
            };
        });
        const pl = [];
        targetCartItems.forEach((item) => {
            const individualTargetCartItemParam = `${item.id}:${item.quantity}`;
            pl.push(individualTargetCartItemParam);
        });
        const additionalParams = {
            loc: targetCheckoutServiceConfig.location ? targetCheckoutServiceConfig.location.id : '0',
            pl: pl.toString()
        };
        // Append each parameter to the URL's searchParams
        Object.entries(additionalParams).forEach(([key, value]) => {
            checkoutUrl.searchParams.append(key, value);
        });
        if (!targetCheckoutServiceConfig.location) {
            checkoutUrl.searchParams.delete('loc');
            checkoutUrl.searchParams.set('fft', 'SHIP');
        }
        const gamRedirectUrl = getPotentialGAMClickTracker();
        let destinationUrl = checkoutUrl.toString();
        if (window.location.hostname === 'localhost' && gamRedirectUrl) {
            // URI needs to be encoded on localHost ONLY for testing purposes
            destinationUrl = encodeURIComponent(destinationUrl);
        }
        const retailerCheckoutUrl = gamRedirectUrl
            ? `${gamRedirectUrl}${destinationUrl}`
            : destinationUrl;
        // console.log("Target Checkout URL:", retailerCheckoutUrl);
        // Open Target checkout URL in new tab
        window.open(retailerCheckoutUrl, '_blank');
        // And return the value so we can use it in telemetry of the parent application
        return retailerCheckoutUrl;
    }
};
export default targetCheckout;
